export default "__VITE_ASSET__ClWrbsQp__"